import React, { useCallback } from 'react'
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

/**
 * Component that renders Stripe's embedded checkout iframe within a dialog
 * Handles payment completion by polling the backend for subscription updates
 */

interface EmbeddedCheckoutProps {
  clientSecret: string
  onComplete: () => void
}

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || import.meta.env.VITE_STRIPE_PUBLIC_KEY_TEST)

const EmbeddedCheckoutComponent: React.FC<EmbeddedCheckoutProps> = ({ clientSecret, onComplete }) => {
  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{
          clientSecret,
          onComplete: useCallback(() => {
            // Payment completed, trigger the callback to handle subscription verification
            onComplete()
          }, [onComplete]),
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}

export default EmbeddedCheckoutComponent
